import instObj from '@/backend/axios-instances'

const resource = "/estimations/detail"
const instance = instObj.baseInstance

export default {
  get(estimationDetailId, parameters) {
    return instance.get(`${resource}/${estimationDetailId}`, { params: parameters });
  },
  put(estimationDetailId, data, parameters) {
    return instance.put(`${resource}/${estimationDetailId}`, data, { params: parameters });
  },
  delete(estimationDetailId) {
    return instance.delete(`${resource}/${estimationDetailId}`);
  }
}
